/**
 * 加载模块
 * @param {*} resolve
 * @param {*} name
 */
const lazyLoading = (resolve, name) => {
    require.ensure([], function(require) {
        resolve(require(`@/views/${name}/index.vue`));
    });
};

export default lazyLoading;
